import { IS_HSL_SERVICE_ENVIRONMENT, SELECTED_PTA_STORAGE_KEY } from 'Util/constants'
import { useEffect } from 'react'

export const useSelectedPta = (pta?: string) => {
  const syncSelectedPta = (selectedPta: string) => {
    if (IS_HSL_SERVICE_ENVIRONMENT) return
    if (selectedPta) {
      localStorage.setItem(SELECTED_PTA_STORAGE_KEY, selectedPta)
    } else {
      localStorage.removeItem(SELECTED_PTA_STORAGE_KEY)
    }
  }

  useEffect(() => {
    if (IS_HSL_SERVICE_ENVIRONMENT) return
    if (pta) {
      localStorage.setItem(SELECTED_PTA_STORAGE_KEY, pta)
    } else {
      localStorage.removeItem(SELECTED_PTA_STORAGE_KEY)
    }
  }, [pta])

  return syncSelectedPta
}
